module.exports = __webpack_public_path__ + "img/circle-envelope.739b7026.svg";